import { useEffect, useState } from 'react';

export const NAV_SCROLL_SHADOW =
	'0 0 1px 0 rgba(9, 30, 66, 0.08), 0 4px 8px 0 rgba(9, 30, 66, 0.08)';

export const useNavScrollShadow = () => {
	// Keep server and initial client markup consistent, including restored scroll positions.
	const [hasScrolled, setHasScrolled] = useState(false);

	useEffect(() => {
		const updateShadow = () => setHasScrolled(window.scrollY > 0);
		updateShadow();
		window.addEventListener('scroll', updateShadow, { passive: true });
		return () => window.removeEventListener('scroll', updateShadow);
	}, []);

	return hasScrolled;
};
